/* eslint-disable complexity */
import {
  Component,
  HostListener,
  Input,
  OnChanges,
  OnInit,
} from '@angular/core'
import { Subscription } from 'rxjs'
import { AEMChunk } from 'src/app/services/AEM/aem-chunk.model'
import { CentralContentService } from 'src/app/services/content/central-content.service'
import { AdobeLaunchService } from 'src/server/adobe-launch/adobe-launch.service'

import { NavTabGroup } from './nav-tab-group.model'
import { NavTabGroupService } from './nav-tab-group.service'

@Component({
  selector: 'nav-tab-group',
  templateUrl: './nav-tab-group.component.html',
  styleUrls: ['./nav-tab-group.component.scss'],
})
export class NavTabGroupComponent implements OnInit, OnChanges {
  navTabGroupModel: NavTabGroup
  navTabGroupSubscription: Subscription
  advisedOnly: AEMChunk
  aemContentSub: Subscription
  fundNonTransferableToVGIMsg: boolean
  nonFundAccessMsg: boolean

  constructor(
    private readonly navTabGroupService: NavTabGroupService,
    private readonly centralContentService: CentralContentService,
    public adobeLaunchService: AdobeLaunchService,
  ) {}

  @Input() tickerOrFundId: string
  @Input() barChartSection: string
  @Input() hasProxyVotingContent: boolean = false
  @Input() proxyVotingContent: string = ''

  activeTabItem = ' '
  fundIdPath = ''
  innerWidth: number
  opneItem = ''
  initialLoad = true
  urlPrefix: any
  @HostListener('window:scroll', [])
  onWindowScroll() {
    const sections = document.querySelectorAll('section')
    this.scroll(sections)
  }

  scroll(elements) {
    // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    if (this.innerWidth >= 992) {
      // eslint-disable-next-line complexity
      elements.forEach((section) => {
        // eslint-disable-next-line complexity
        if (
          section.getAttribute('id') === 'Dashboard' ||
          section.getAttribute('id') === 'overview' ||
          section.getAttribute('id') === 'performance-fees' ||
          section.getAttribute('id') === 'price' ||
          section.getAttribute('id') === 'portfolio-composition' ||
          section.getAttribute('id') === 'distributions' ||
          section.getAttribute('id') === 'fund-management' ||
          section.getAttribute('id') === 'proxy-voting' ||
          section.getAttribute('id') === 'fund-literature' ||
          section.getAttribute('id') === 'disclosures'
        ) {
          // eslint-disable-next-line @typescript-eslint/no-magic-numbers
          const sectionTop = section.offsetTop - 150
          if (scrollY > sectionTop) {
            this.activeTabItem = section.getAttribute('id')

            //Tabs need 'active' class for correct CSS to apply to activeTabItem
            if (
              this.activeTabItem !== 'Dashboard' &&
              this.activeTabItem !== 'disclosures'
            ) {
              this.setActiveClass(this.activeTabItem + '-tab')
            } else {
              this.clearActiveClass()
            }
          }
        }
      })
      this.urlPrefix = window.location.pathname.split('#')[0]
      const url =
        this.activeTabItem === 'Dashboard' ||
        this.activeTabItem === 'disclosures'
          ? ''
          : `#${this.activeTabItem}`
      window.history.replaceState({}, '', `${this.urlPrefix}${url}`)
    }
  }
  ngOnInit() {
    console.log('🔵 [NavTabGroup] ngOnInit - Component initializing')
    console.log('📥 [NavTabGroup] Input values received from parent:')
    console.log('   - hasProxyVotingContent:', this.hasProxyVotingContent)
    console.log('   - proxyVotingContent:', this.proxyVotingContent)
    console.log('   - tickerOrFundId:', this.tickerOrFundId)

    this.fundIdPath = `${this.tickerOrFundId}#`
    this.navTabGroupSubscription = this.navTabGroupService
      .getModelData()
      .subscribe((model) => {
        this.navTabGroupModel = model

        if (!this.navTabGroupModel.isFundAccessFund) {
          if (!this.navTabGroupModel.isFundTransferableToVGI) {
            this.fundNonTransferableToVGIMsg = true
          } else {
            this.nonFundAccessMsg = true
          }
        }
      })
    this.detectScreenSize()
    this.aemContentSub = this.centralContentService.aemContent$.subscribe(
      (content) => {
        this.parseAEMContent(content)
      },
    )

    console.log('✅ [NavTabGroup] ngOnInit - Component initialized')
  }
  ngOnChanges(): void {
    console.log('🟡 [NavTabGroup] ngOnChanges - Input values changed')
    console.log('📥 [NavTabGroup] Current input values:')
    console.log('   - hasProxyVotingContent:', this.hasProxyVotingContent)
    console.log('   - proxyVotingContent:', this.proxyVotingContent)
    console.log('   - initialLoad:', this.initialLoad)

    if (this.initialLoad) {
      console.log(
        '⏰ [NavTabGroup] First load - setting navbar with 500ms delay',
      )
      setTimeout(() => {
        this.setNavBar()
        // eslint-disable-next-line @typescript-eslint/no-magic-numbers
      }, 500)
    } else {
      console.log(
        '🔄 [NavTabGroup] Subsequent change - setting navbar immediately',
      )
      this.setNavBar()
    }
    this.initialLoad = false

    console.log('✅ [NavTabGroup] ngOnChanges - Changes processed')
  }

  parseAEMContent(content) {
    this.advisedOnly = this.centralContentService.getContentByBody(
      'configuration_vanguard_advised_only_icon',
      content,
    )
  }

  advisedBanner(fundId: string) {
    // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    if (
      this.advisedOnly !== undefined &&
      // eslint-disable-next-line @typescript-eslint/no-magic-numbers
      this.advisedOnly.contentValue.indexOf(fundId) > -1
    ) {
      return true
    }
    return false
  }

  scrollToTab(tab) {
    //set active class
    let tabId = tab + '-tab'
    this.setActiveClass(tabId)

    this.adobeLaunchService.subPageTabEvent(
      `${this.tickerOrFundId}:NAV BAR:${tab}`,
    )
    const section = document.getElementById(tab)
    const focusSection = document.getElementById(tab + '_header')
    focusSection.setAttribute('tabindex', '-1')
    focusSection.focus()
    focusSection.removeAttribute('tabindex')
    const sectionTop = section.offsetTop
    // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    window.scrollTo(0, sectionTop - 125)
  }

  setActiveClass(tabId) {
    //unset active class on all tabs
    this.clearActiveClass()

    //set active class on tabId
    document.getElementById(tabId).classList.add('active')
  }

  clearActiveClass() {
    let tabItems = document.getElementsByClassName('tab-item')
    for (let item of tabItems) {
      item.classList.remove('active')
    }
  }

  setNavBar() {
    const fragment = this.barChartSection
    this.activeTabItem = fragment
    const section = document.getElementById(fragment)
    if (section !== null && section !== undefined) {
      const sectionTop = section.offsetTop
      // eslint-disable-next-line @typescript-eslint/no-magic-numbers
      window.scrollTo(0, sectionTop - 125)
    }
  }
  detectScreenSize() {
    this.innerWidth = window.innerWidth
  }

  toggleAccordion(sectionName: string) {
    //flip caret icon
    const downCaretIcon = document.getElementById(sectionName + '-caret-down')
    const upCaretIcon = document.getElementById(sectionName + '-caret-up')

    if (downCaretIcon.classList.contains('hidden')) {
      upCaretIcon.classList.add('hidden')
      downCaretIcon.classList.remove('hidden')
    } else if (upCaretIcon.classList.contains('hidden')) {
      downCaretIcon.classList.add('hidden')
      upCaretIcon.classList.remove('hidden')
    }

    //hide/show body content
    const body = document.getElementById(sectionName + '-body')
    const BODY_ELEMENT_CLASS = 'c11n-accordion__body'

    if (body.classList.contains(BODY_ELEMENT_CLASS)) {
      body.classList.remove(BODY_ELEMENT_CLASS)
    } else {
      body.classList.add(BODY_ELEMENT_CLASS)
    }
  }
  isBuyAvailable(): boolean {
    const profile = this.navTabGroupModel
    if (!profile) return false

    const isNotClosed = !profile.isClosed && !profile.isClosedToNewInvestors
    const isNot529 = !profile.is529
    const isAdvisedBanner = this.advisedBanner(profile.fundId)
    const isInternalFund = profile.isInternalFund
    const isExternalFundValid =
      profile.isExternalFund &&
      !this.fundNonTransferableToVGIMsg &&
      !this.nonFundAccessMsg &&
      isNotClosed
    const isExternalETF = profile.isExternalFund && profile.isETF
    return (
      isNotClosed &&
      isNot529 &&
      !isAdvisedBanner &&
      (isInternalFund || isExternalFundValid || isExternalETF)
    )
  }
  isCompareAvailable(): boolean {
    const profile = this.navTabGroupModel
    if (!profile) return false

    const isExternalFundValid =
      profile.isExternalFund &&
      !this.fundNonTransferableToVGIMsg &&
      !this.nonFundAccessMsg
    const isExternalETF = profile.isExternalFund && profile.isETF

    return (
      (profile.isInternalFund && !profile.is529) ||
      isExternalFundValid ||
      isExternalETF
    )
  }
}
